import { useHealth } from "@/context/HealthContext";
import { HCard } from "@/components/health-kit";
import { ClipboardList, Lock, Milestone, Info } from "lucide-react";

function Chips({ items }) {
  return <div className="flex flex-wrap gap-2">{items.map((t) => <span key={t} className="text-sm px-3 py-1.5 rounded-sm bg-[#050C11] border border-slate-700 text-slate-200">{t}</span>)}</div>;
}

export function Validation() {
  const { ht } = useHealth();
  const metrics = ["val_m1", "val_m2", "val_m3", "val_m4", "val_m5", "val_m6", "val_m7"];
  return (
    <div className="space-y-6 ngx-fade-in max-w-4xl" data-testid="health-validation">
      <div className="flex items-center gap-3">
        <div className="h-12 w-12 rounded-md bg-teal-600/15 border border-teal-800 flex items-center justify-center"><ClipboardList className="h-6 w-6 text-teal-400" /></div>
        <div><h1 className="font-display text-2xl font-bold text-slate-50">{ht("nav_validation")}</h1><p className="text-sm text-slate-400">{ht("notClinical")}</p></div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {metrics.map((m) => (
          <HCard key={m} className="p-4 flex items-center justify-between" data-testid={`val-${m}`}>
            <span className="text-sm text-slate-200">{ht(m)}</span>
            <span className="text-[10px] font-mono font-semibold uppercase tracking-widest px-2.5 py-1 rounded-sm bg-amber-950/40 border border-amber-800 text-amber-300">{ht("toBeValidated")}</span>
          </HCard>
        ))}
      </div>
    </div>
  );
}

export function Governance() {
  const { ht } = useHealth();
  const items = ["gov_1", "gov_2", "gov_3", "gov_4", "gov_5", "gov_6", "gov_7"];
  return (
    <div className="space-y-6 ngx-fade-in max-w-4xl" data-testid="health-governance">
      <div className="flex items-center gap-3">
        <div className="h-12 w-12 rounded-md bg-teal-600/15 border border-teal-800 flex items-center justify-center"><Lock className="h-6 w-6 text-teal-400" /></div>
        <div><h1 className="font-display text-2xl font-bold text-slate-50">{ht("nav_governance")}</h1></div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {items.map((i) => <HCard key={i} className="p-4 text-sm text-slate-200">{ht(i)}</HCard>)}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <HCard className="p-4 border-teal-900/50 bg-teal-950/10 text-sm text-teal-200" data-testid="gov-gdpr">{ht("gov_gdpr")}</HCard>
        <HCard className="p-4 border-teal-900/50 bg-teal-950/10 text-sm text-teal-200" data-testid="gov-mdr">{ht("gov_mdr")}</HCard>
      </div>
    </div>
  );
}

export function Roadmap() {
  const { ht } = useHealth();
  const phases = [
    { k: "rm_p1", s: ht("rm_current"), tone: "text-emerald-400 border-emerald-700 bg-emerald-950/30" },
    { k: "rm_p2", s: ht("rm_next"), tone: "text-teal-400 border-teal-700 bg-teal-950/30" },
    { k: "rm_p3", s: ht("rm_future"), tone: "text-violet-400 border-violet-700 bg-violet-950/30" },
    { k: "rm_p4", s: "", tone: "text-slate-400 border-slate-700 bg-[#050C11]" },
    { k: "rm_p5", s: "", tone: "text-slate-400 border-slate-700 bg-[#050C11]" },
  ];
  return (
    <div className="space-y-6 ngx-fade-in max-w-3xl mx-auto" data-testid="health-roadmap">
      <div className="flex items-center gap-3">
        <div className="h-12 w-12 rounded-md bg-teal-600/15 border border-teal-800 flex items-center justify-center"><Milestone className="h-6 w-6 text-teal-400" /></div>
        <h1 className="font-display text-2xl font-bold text-slate-50">{ht("nav_roadmap")}</h1>
      </div>
      <div className="flex flex-col items-center gap-2">
        {phases.map((p, i) => (
          <div key={p.k} className="w-full flex flex-col items-center">
            <div className={`w-full max-w-md flex items-center gap-3 px-5 py-4 rounded-md border ${p.tone}`} data-testid={`roadmap-${p.k}`}>
              <span className="font-mono text-xs text-slate-500">{String(i + 1).padStart(2, "0")}</span>
              <span className="text-sm font-medium text-slate-100 flex-1">{ht(p.k)}</span>
              {p.s && <span className="text-[10px] font-mono font-semibold uppercase tracking-widest">{p.s}</span>}
            </div>
            {i < phases.length - 1 && <span className="text-slate-600 py-1">↓</span>}
          </div>
        ))}
      </div>
    </div>
  );
}
